// extracted by mini-css-extract-plugin
export var askAiIcon = "_nd-j";
export var category = "_nd-9";
export var categoryHeader = "_nd-e";
export var container = "_nd-0";
export var group = "_nd-a";
export var groupItems = "_nd-f";
export var groupSeparator = "_nd-k";
export var loading = "_nd-1";
export var noResults = "_nd-3";
export var placeholder = "_nd-2";
export var resultContent = "_nd-5";
export var resultIcon = "_nd-c";
export var resultItem = "_nd-g";
export var resultMeta = "_nd-8";
export var resultSubtitle = "_nd-7";
export var resultSuffix = "_nd-i";
export var resultTitle = "_nd-6";
export var resultsList = "_nd-4";
export var searchGroup = "_nd-d";
export var selected = "_nd-h";
export var subgroup = "_nd-b";